<template>
  <div>
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      @click="operationBtn"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('basicData.ImportTaxes')"
      style="display: inline-block;margin-left: 20px;"
    />
  </div>
</template>
<script>
const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';
export default {
  name: 'ImportIcms',
  components: {
    uploadExcel: () => import('@/components/UploadExcel/index.vue')
  },
  props: {
    importExcelColumns: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data() {
    return {};
  },

  methods: {
    async operationBtn() {
      const that = this;
      async function downloadTemplate() {
        // 创建workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet');

        // 设置州代码
        const states = that.importExcelColumns.map((item) => {
          if (item.prop !== 'sendTwoCode') {
            return item.label;
          }
        });

        const cellLength = states.length;

        // 定义数据源
        // const dataMatrix = [
        //   [], // AC行
        //   [], // AL行
        //   [], // AM行
        //   [] // AP行
        // ];

        // 设置表头样式
        const headerStyle = {
          font: { bold: true },
          alignment: { horizontal: 'center' }
        };

        // 添加横向州标签
        states.forEach((state, colIndex) => {
          const cell = worksheet.getCell(1, colIndex + 1);
          cell.value = state;
          cell.style = headerStyle;
        });

        // 添加纵向州标签
        states.forEach((state, rowIndex) => {
          const rowNumber = rowIndex + 1;

          // 添加纵向州标签
          worksheet.getCell(`A${rowNumber}`).value = state;
          worksheet.getCell(`A${rowNumber}`).style = headerStyle;

          // 填充数据
          // dataMatrix[rowIndex].forEach((value, colIndex) => {
          //   const cell = worksheet.getCell(rowNumber, colIndex + 2);
          //   cell.value = value;
          //   cell.numFmt = '0.00'; // 保留两位小数
          // });
        });

        // 设置列宽
        worksheet.columns = [
          { width: 30 }, // A列
          ...Array(cellLength).fill({ width: 20 }) // B-E列
        ];
        // 构建表头
        worksheet.getCell('A1').value = '发件州 ↓ 收件州 →';
        worksheet.getCell('A1').style = headerStyle;
        // worksheet.mergeCells('A1:A1');
        console.log(worksheet);
        // 保存文件
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('basicData.ICMSTaxTemplate') + '.xlsx';
        saveAs(blob, saveName);
      }
      await downloadTemplate();
    },

    // 导入
    importLogistics(array) {
      const arrData = array[0].results;
      console.log(arrData);
      const list = [];
      try {
        arrData.forEach((row, index) => {
          const sendTwoCode = row['发件州 ↓ 收件州 →']; // 获取发件州
          Object.entries(row).forEach(([key, value]) => {
            if (key !== '发件州 ↓ 收件州 →') { // 排除发件州键
              // 校验 value 是否为数字且最多保留两位小数
              const isValidNumber = /^[0-9]+(\.[0-9]{1,2})?$/.test(value); // 正则表达式校验
              if (!isValidNumber) {
                const rowInfo = this.$t('basicData.row') + (index + 1) + this.$t('basicData.line') + sendTwoCode + '+' + key;
                const errorMsg = this.$t('basicData.NumericWithTwoDecimals');
                throw new Error(`${rowInfo} ${errorMsg}: ${value}`);
              }
              list.push({
                sendTwoCode: sendTwoCode,
                receivingTwoCode: key,
                taxation: value
              });
            }
          });
        });

        // console.log(list);
        this.$emit('importChange', list);
      } catch (error) {
        console.log(error);
        this.$message.error(error.message);
        throw error;
      }
    }
  }
};
</script>
